import React from "react";
import { Grid } from "@mui/material";
import { ActualTurns } from "./states/ActualTurns";
import { HistoryTurns } from "./states/HistoryTurns";
import { useParams } from "react-router-dom";
import { TramitTurns } from './states/TramitTurns';

export const Turns = () => {

    const { id } = useParams();

    return (
        <Grid container spacing={ 1 }>
            <Grid item='true' xs={ 12 } sm={ 12 } md={ 12 } lg={ 12 } xl={ 12 }>
                <ActualTurns sede={ id } />
            </Grid>

            <Grid item='true' xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 } xl={ 6 }>
                <TramitTurns sede={ id } />
            </Grid>

            <Grid item='true' xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 } xl={ 6 }>
                <HistoryTurns sede={ id } />
            </Grid>
        </Grid>       
    );
}